import { CdkScrollable } from '@angular/cdk/scrolling';
import { AfterViewInit, ChangeDetectionStrategy, Component, computed, contentChild, effect, inject, Input, OnDestroy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { ResizableModule } from 'angular-resizable-element';
import { NavShellService, NavShellState } from 'libs/shared/domain/src/lib/infrastructure/nav-shell.service';
import { ScrollService } from 'libs/shared/domain/src/lib/infrastructure/scroll.service';
import { TreeScrollService } from 'libs/shared/domain/src/lib/infrastructure/tree-scroll.service';
import { SharedChaptersTreeComponent } from 'libs/shared/feature-chapters-tree/src/lib/chapters-tree.component';
import { DrawerContainerComponent } from 'libs/shared/ui-common/src/lib/components/drawer/drawer-container.component';
import { DrawerContentComponent } from 'libs/shared/ui-common/src/lib/components/drawer/drawer-content.component';
import { DrawerComponent, DrawerLeftDirective } from 'libs/shared/ui-common/src/lib/components/drawer/drawer.component';
import { IsMobileService } from 'libs/shared/util-common/src/lib/directives/is-mobile.service';

import { DrawerMode } from '@treetop/shared/model';

@Component({
  standalone: true,
  imports: [
    SharedChaptersTreeComponent,
    MatTooltipModule,
    MatSidenavModule,
    TranslocoModule,
    ResizableModule,
    RouterModule,
    MatTooltipModule,
    DrawerContainerComponent,
    DrawerContentComponent,
    DrawerLeftDirective,
    DrawerComponent,
    MatIconModule,
  ],
  selector: 'shared-main-sidebar',
  templateUrl: './main-sidebar.component.html',
  styleUrls: ['./main-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainSidebarComponent implements AfterViewInit, OnDestroy {
  public navShellService = inject(NavShellService);
  protected treeScrollService = inject(TreeScrollService);
  protected isMobileService = inject(IsMobileService);
  private scrollService = inject(ScrollService);

  @Input() public readonly?: boolean = false;

  private scrollable = contentChild(CdkScrollable);

  protected drawerMode = computed<DrawerMode>(() => (this.isMobileService.isMobile() ? 'over' : 'side'));
  protected sidebarOpen = computed(() => this.navShellService.sideNavState() === NavShellState.open);

  constructor() {
    effect(() => {
      if (this.isMobileService.isMobile()) {
        this.navShellService.close();
      } else {
        this.navShellService.open();
      }
    });
  }

  public onSidenavToggle() {
    this.navShellService.toggle();
  }

  public ngAfterViewInit(): void {
    this.scrollService.init(this.scrollable());

    this.scrollable()
      .elementScrolled()
      .subscribe((event: Event) => {
        this.treeScrollService.captureScrollEvent(event);
      });
  }

  public ngOnDestroy(): void {
    this.navShellService.close();
  }
}
